// Scheduling for weekly prompts, used by the admin panel.
//
// A prompt runs Friday 00:00 through the following Thursday 23:59, local time, and the
// panel offers nothing else: no mid-week start, no odd length, no date already gone by.
// Free-form date fields are what let a live prompt get scheduled a month into the future,
// which made it lead the daily email every day until someone noticed.
//
// Every function takes the current time so callers can be tested at a fixed date.

var PROMPT_WEEKS_AHEAD = 12;

// How far past the usual horizon the list will reach to find a free week, so a run of
// booked weeks cannot leave the picker with nothing selectable.
var PROMPT_WEEKS_MAX = 52;

// The first Friday 00:00 strictly after `now`. On a Friday that means next week, since
// this week's window has already opened and its email has probably already gone out.
function nextFridayStart(now) {
  var from = now ? new Date(now) : new Date();
  var friday = new Date(from);
  friday.setDate(friday.getDate() + ((5 - friday.getDay() + 7) % 7));
  friday.setHours(0, 0, 0, 0);
  if (friday.getTime() <= from.getTime()) {
    friday.setDate(friday.getDate() + 7);
  }
  return friday;
}

// The Thursday 23:59 that closes the week opening on `start`. One minute short of seven
// days, so consecutive weeks tile without overlapping.
function weekEndFor(start) {
  var end = new Date(start);
  end.setDate(end.getDate() + 6);
  end.setHours(23, 59, 0, 0);
  return end;
}

function formatWeekRange(start, end) {
  var opts = { weekday: 'short', month: 'short', day: 'numeric' };
  return (
    start.toLocaleDateString(undefined, opts) + ' - ' + end.toLocaleDateString(undefined, opts)
  );
}

// The scheduled prompt overlapping a window, if any. Declared outside the loop below so
// it closes over nothing the loop reassigns.
function clashFor(scheduled, start, end) {
  return scheduled.filter(function (s) {
    return s.start < end.getTime() && s.end > start.getTime();
  })[0];
}

// The upcoming Friday weeks, each tagged with the prompt already holding it.
function getFridayWeeks(promptList, now, count) {
  var scheduled = (promptList || [])
    .filter(function (p) {
      return p.activateAt && p.deactivateAt;
    })
    .map(function (p) {
      return {
        id: p.id,
        name: p.name,
        start: new Date(p.activateAt).getTime(),
        end: new Date(p.deactivateAt).getTime(),
      };
    });

  var weeks = [];
  var candidate = nextFridayStart(now);
  var target = count || PROMPT_WEEKS_AHEAD;
  var limit = Math.max(target, PROMPT_WEEKS_MAX);
  for (var i = 0; i < limit; i++) {
    var start = new Date(candidate);
    var end = weekEndFor(start);
    var clash = clashFor(scheduled, start, end);
    weeks.push({
      value: String(start.getTime()),
      start: start,
      end: end,
      takenBy: clash ? clash.name : null,
      takenById: clash ? clash.id : null,
    });
    candidate.setDate(candidate.getDate() + 7);
    // Past the usual horizon, keep going only until something is selectable.
    if (weeks.length >= target && firstFreeWeek(weeks)) break;
  }
  return weeks;
}

function firstFreeWeek(weeks) {
  var free = (weeks || []).filter(function (w) {
    return !w.takenBy;
  });
  return free.length > 0 ? free[0] : null;
}

function weekLabel(week) {
  var range = formatWeekRange(week.start, week.end);
  return week.takenBy ? range + ' (taken by ' + week.takenBy + ')' : range;
}

export {
  PROMPT_WEEKS_AHEAD,
  PROMPT_WEEKS_MAX,
  nextFridayStart,
  weekEndFor,
  formatWeekRange,
  getFridayWeeks,
  firstFreeWeek,
  weekLabel,
};
